import { CategoryType } from './types.ts'

interface CatégorieProps {
  category: CategoryType
}

export default function Catégorie({ category }: CatégorieProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {category.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {category.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Description :</strong>
        {category.description?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Actif :</strong>
        {category.active?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {category.community_id?.toString()}
      </p>
    </div>
  )
}
